<autocomplete-list-item (clicked)="triggerEvent()">
  <div class="header">{{ item.code }} – {{ item.name }}</div>
  <div *ngIf="item.synonyms?.length">{{ item.synonyms.slice(0, 3).join('; ') }}{{ item.synonyms.length > 3 ? '…' : '' }}</div>
</autocomplete-list-item>
